import { HttpClient } from '@prezly/theme-kit-nextjs';

export const http = HttpClient.create();
